import React from "react";
import moment from "moment";

export const DateColumnFormatter = (cellContent, row) => (
  <span><p style={{ marginBottom:'0' }}>{ moment(cellContent).format("DD MMM") } { moment(cellContent).format("YYYY") }</p>
  <p style={{ marginBottom:'0' }} className="text-muted">{ moment(cellContent).format("HH:mm") }</p></span>
);
